/**
 * Tooltip delay duration in milliseconds for deprecation notices
 */
export const TOOLTIP_DELAY_MS = 1000;

export const DEPRECATED_NODES = {
  slides: {
    // Match by display_name containing 'slides' (case-insensitive)
    matcher: (displayName: string) =>
      displayName?.toLowerCase().includes('slides') ?? false,
    message:
      'The Slides node is being deprecated. Please update your workflow to use the PowerPoint or EY PowerPoint node by Feb 20, 2026. If you need help making the change, our team is happy to assist.',
  },
} as const;

/**
 * Checks if a workflow node is deprecated based on its display name
 * @param displayName - The display name of the node to check
 * @returns true if the node is deprecated, false otherwise
 */
export const isNodeDeprecated = (displayName: string): boolean => {
  return Object.values(DEPRECATED_NODES).some((node) =>
    node.matcher(displayName),
  );
};

/**
 * Gets the deprecation message for a workflow node
 * @param displayName - The display name of the node
 * @returns The deprecation message if the node is deprecated, null otherwise
 */
export const getDeprecationMessage = (displayName: string): string | null => {
  const deprecatedNode = Object.values(DEPRECATED_NODES).find((node) =>
    node.matcher(displayName),
  );
  return deprecatedNode?.message ?? null;
};
